export const InvoiceStatusesLabels = {
  ACTIVE: 'Vigentes',
  DRAFT: 'Borrador',
  ISSUED: 'Emitida',
  PAID: 'Pagada',
  CANCELLED: 'Cancelada',
  OVERDUE: 'Vencida'
}

export const InvoiceStatusesColors = {
  DRAFT: '#CCCCCC',
  ISSUED: '#FF9E00',
  PAID: '#28C184',
  CANCELLED: '#A2142F'
}

export const InvoiceStatuses = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED'
}

export const InvoiceStatusesFilterOptions = { ...InvoiceStatusesLabels, ACTIVE: 'Vigentes' }